/**
 * 📄 CSV CONTROLLER
 * Location: src/registered/common/parsers/CsvController.js
 * Specialized parser for flat-file ESG data exports.
 */
import Papa from 'papaparse';

export const CsvController = {
    /**
     * Converts binary buffers to strings and validates row/column integrity.
     */
    execute: async (buffer, onProgress) => {
        onProgress({ stage: 'OPEN_FILE', status: 'IN_PROGRESS', label: 'Parsing CSV strings...' });
        
        // Convert binary to UTF-8 text for the parser
        const text = new TextDecoder().decode(buffer);
        
        return new Promise((resolve, reject) => {
            Papa.parse(text, {
                preview: 50, // Only process the header + first 50 rows for discovery speed
                skipEmptyLines: true,
                complete: (results) => {
                    // Success Gate: Check if we actually found data
                    if (results.data.length === 0) {
                        onProgress({ stage: 'OPEN_FILE', status: 'FAIL', label: 'CSV is empty.' });
                        return reject(new Error("The CSV file contains no readable data."));
                    }

                    onProgress({ stage: 'OPEN_FILE', status: 'SUCCESS', label: 'CSV structure validated.' });
                    
                    resolve({
                        format: 'CSV',
                        worksheets: [{
                            name: 'CSV_DATA_ROOT',
                            headers: results.data[0], // Identify Columns
                            sampleRows: results.data.slice(1, 11), // Identify Data
                            columnCount: results.data[0].length,
                            rowCount: results.meta.cursor // Approximate row count from preview
                        }]
                    });
                },
                error: (err) => {
                    onProgress({ stage: 'OPEN_FILE', status: 'FAIL', label: 'CSV Syntax Error.' });
                    reject(new Error(`CSV Parse Error: ${err.message}`));
                }
            });
        });
    }
};